import BlogDetail from "../../../commonComponents/blogDetail";

const BlogLeftClassicContainer = () => {
  return <BlogDetail />;
};

export default BlogLeftClassicContainer;
